const PharmacyRoutes = {
  getPharmacies: 'marketplace/pharmacies',
};

export default PharmacyRoutes